import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import type { ButtonProps } from "components/Button/Button";
import { composeEventHandlers } from "utils";
import useCarousel from "../hooks/useCarousel";
import useCarouselActions from "../hooks/useCarouselActions";

export interface CarouselBackButtonProps extends ButtonProps {}

/**
 * @description Shows the preceding slide. Reads "Back" unless children are given.
 * Calling `preventDefault` in `onClick` keeps the current slide.
 */
function CarouselBackButton(props: CarouselBackButtonProps) {
  const { onClick, children, ...rest } = props;

  const { t } = useTranslation();
  const { slidesId } = useCarousel();
  const { previous } = useCarouselActions();

  const handleOnClick = useMemo(() => composeEventHandlers(onClick, previous), [onClick, previous]);

  return (
    <Button aria-controls={slidesId} {...rest} onClick={handleOnClick}>
      {children ?? t("global.back_button_text")}
    </Button>
  );
}

export default CarouselBackButton;
